import React from "react";
import { Thumbnail } from "@culturehq/components";

import { rsvpResponseTypeLabelFrom } from "constants/rsvpResponseTypes";
import { useProfile } from "app/context";
import { ProfileLink } from "app/links";

import getUserName from "app/utils/getUserName";
import AttendeeDropdown from "./AttendeeDropdown";

const AttendeeStatus = ({ isHost, rsvp, event, onRsvpUpdate, onEventUpdate }) => {
  if (!isHost) {
    return <p>{rsvpResponseTypeLabelFrom(rsvp.responseType)}</p>;
  }

  return (
    <AttendeeDropdown
      rsvp={rsvp}
      event={event}
      onRsvpUpdate={onRsvpUpdate}
      onEventUpdate={onEventUpdate}
    />
  );
};

const Attendee = ({ rsvp, event, onRsvpUpdate, onEventUpdate }) => {
  const { profile } = useProfile();
  const { user } = rsvp;

  return (
    <tr>
      <td>
        <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
      </td>
      <td>
        <ProfileLink user={user} />
      </td>
      <td>
        <AttendeeStatus
          isHost={event.isUserHostOrAdmin(profile)}
          rsvp={rsvp}
          event={event}
          onRsvpUpdate={onRsvpUpdate}
          onEventUpdate={onEventUpdate}
        />
      </td>
    </tr>
  );
};

export default Attendee;
